export default {
  setTemplateDesign(state, value) {
    state.templateDesign = value;
  },
  setTemplateData(state, value) {
    state.templateData = value;
  },
  setFormData(state, value) {
    state.formData = value;
  },
  setTemplates(state, value) {
    state.templates = value;
  },
  setCampaigns(state, value) {
    state.campaigns = value;
  },
  setTemplateId(state, value) {
    state.templateId = value;
  },
  setTemplate(state, value) {
    state.template = value;
  },
  setSegments(state, value) {
    state.segments = value;
  },
  setSegment(state, value) {
    state.segment = value;
  },
  setSegmentObj(state, value) {
    state.segmentObj = value;
  },
  setSegmentSubscribers(state, value) {
    state.segmentSubscribers = value;
  },
  showSegmantAddDialog(state) {
    state.segmentAddDialog = true;
  },
  hideSegmantAddDialog(state) {
    state.segmentAddDialog = false;
  },
  showSegmantUpdateDialog(state) {
    state.segmentUpdateDialog = true;
  },
  hideSegmantUpdateDialog(state) {
    state.segmentUpdateDialog = false;
  },
  hideSegmantCloneDialog(state) {
    state.segmentCloneDialog = false;
  },
  showSegmantCloneDialog(state) {
    state.segmentCloneDialog = true;
  },
  setSegmentGroups(state, value) {
    state.segmentGroups = value;
  },
  setHasChanges(state, value) {
    state.hasChanges = value;
  },
  setCampaignSavedData(state, value) {
    let item = value;
    // console.log("item", item);

    let data = {};
    data.name = item.name;
    data.start = item.start;
    data.end = item.end;
    data.repeat_on = item.repeat_on;
    data.categories = item.selectedItems;
    data.selectedDays = item.selectedDays;
    data.schedules = item.schedules;
    // if (item.repeat_on !== "daily") {
    //   data.schedules = item.specific_days;
    // }
    // if (item.repeat_on === "daily") {
    //   data.schedules = item.daily;
    // }
    state.campaignSavedData = data;
    window.localStorage.setItem("other-campaign", JSON.stringify(data));
  },
  setFlows(state, value) {
    state.flows = value;
  },
  setFlowId(state, value) {
    state.flowId = value;
  },
  setFlowSequence(state, value) {
    state.flowSequence = value;
  },
  setSelectedLocations(state, value) {
    state.campaignSelectedLocations = value;
    window.localStorage.setItem("other-campaign-locations", value);
  },
  setInitialMenuItems(state, value) {
    state.initialMenuItems = value;
  },
  showUpdateCampaign(state) {
    state.updateCampaign = true;
  },
  hideUpdateCampaign(state) {
    state.updateCampaign = false;
  },
  showUpdateOtherCampaign(state) {
    state.updateOtherCampaign = true;
  },
  hideUpdateOtherCampaign(state) {
    state.updateOtherCampaign = false;
  },
  setCampaignItem(state, value) {
    state.campaignItem = value;
  },
  setOtherCampaignItem(state, value) {
    state.otherCampaignItem = value;
  },
  setOtherCampaignItems(state, value) {
    state.otherCampaignItems = value;
  }
};
